import axios from 'axios'

export const API = axios.create({
  baseURL: 'https://app.ubs-bg.com/api/',
  withCredentials: true,
})
